module.exports = __webpack_public_path__ + "img/pending.04bdda61.png";